import { render, staticRenderFns } from "./UserCoursesHistoryTable.vue?vue&type=template&id=76a18056"
import script from "./UserCoursesHistoryTable.vue?vue&type=script&lang=js"
export * from "./UserCoursesHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports